import React from "react";
import ReactDom from "react-dom";
import {Router, browserHistory} from "react-router";
import ReactTransitionGroup from "react-addons-css-transition-group";
import {IntlProvider, addLocaleData} from "react-intl";
import {Modal} from "antd-mobile";

import classnames from 'classnames';
import "./static/styles/basic.scss";
import * as ShopRoute from "./config/route-config";
import {System} from "./config/route-fetch";
import {BusinessUtil} from "./utils/BusinessUtil";
import AppUtil from "./utils/app-util";
import StorageUtil from "./utils/storage-util";
import {SystemConst} from "./utils/constant";
import {CommonUtil, InitUtil} from "./utils/common-utils";
import {loadWxConfig} from './utils/WechatUtil';
import HdDialog from "./components/HdDialog/HdDialog";

import zh from 'react-intl/locale-data/zh';
import es from 'react-intl/locale-data/es';
import en from 'react-intl/locale-data/en';

addLocaleData([...zh, ...es,...en]);  // 引入多语言环境的数据

import zh_CN from "./locale/zh_CN"; // 中文
import es_ES from "./locale/es_ES" // 西班牙语
import en_US from "./locale/en_US" // 英语


// 多语言 XIAOMI654321
const messages = {
    'zh': zh_CN,
    'es': es_ES,
    'en': en_US
};
// 消息提示时间
window.ToastDuration = 1.2;
// 获取账号中心信息
const initAuth = () => {
    // app 版本 17620387339
    if (AppUtil.isApp) {
        InitUtil.cleanShopCache();
    }
    const query = CommonUtil.getSearchFromUrl();
    const companyId = StorageUtil.getItem(SystemConst.companyId);
    // 新公司清除所有缓存
    if (query.companyId && query.companyId != companyId) {
        localStorage.clear();
        sessionStorage.clear();
        window.indexedDB.deleteDatabase('YunshlDB');
    }
    // webapp登陆跳转
    if (query.auth_code_) {
        const auth_code_ = JSON.parse(Base64.decode(query.auth_code_));
        // 本地保存登录信息
        CommonUtil.saveStorageFormLogin(auth_code_);
        delete query.auth_code_;
        browserHistory.replaceState(null, location.pathname, query);
    }
    // 分享人
    if (query.u) {
        StorageUtil.setItem(SystemConst.shareUserId, query.u, true)
    }
    //分享客户
    if (query.c) {
        StorageUtil.setItem(SystemConst.shareClientId, query.c, true)
    }
    // 删除微信设置信息
    StorageUtil.delItem(SystemConst.wechatData);
};
// 初始化数据
initAuth();

class shopComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: {},
            isLogin: false,
            homePageLoaded: false,
            baseSetting: {},
            lang: 'es', // 本地语言
        };
    }

    componentWillMount() {
        const query = this.props.location.query;
        const companyId = query.companyId ? parseInt(query.companyId) : StorageUtil.getItem(SystemConst.companyId);
        // 获取登陆用户信息
        const ysUser = StorageUtil.getItem(SystemConst.mShop_user);
        const companyTheme = StorageUtil.getItem(SystemConst.companyTheme);
        if (query.code) {
            //state参数有带V的字符的,是微信授权的-- 没带V的不用进入跑接口,以防在做微信支付也需要用到返回的code时,报code已使用的错误
            if (query.state && query.state.indexOf('V') > -1) {
                console.log('获取微信授权信息', query.code);
                // 获取微信授权信息
                InitUtil.getWechatUserInfo(query.code, companyId).then(rs => {
                    if (ysUser) {
                        this.getLoginData();
                    }
                });
            }
        }

        // 设置主题色
        if (companyTheme || ysUser && ysUser.company_theme_) {
            CommonUtil.setTheme(companyTheme || (ysUser && ysUser.company_theme_));
        }
        // 不存在companyId，跳转登陆
        if (!companyId) {
            // Util.message(`缺少企业id,${location.href}`);
            return;
        }

        // 判断是否体验企业
        const isExperience = BusinessUtil.checkExperience(companyId) ? 1 : 0;
        // 设置体验账号信息
        StorageUtil.setItem(SystemConst.isExperience, isExperience);
        // 更新企业id
        StorageUtil.setItem(SystemConst.companyId, companyId);

        // 体验账号,没有登陆人或者登录人id不等于url新id
        if (isExperience && (!ysUser || ysUser.company_id_ !== companyId)) {
            // 自动登陆体验账号，获取公司设置信息
            CommonUtil.toShopExperience();
        }
        // 获取公司详细信息
        InitUtil.getCompany(companyId).then(rs => {
            if (rs.status === 1) {
                if (!rs.data.allow_visitor_ && !isExperience && !ysUser) {
                    // 非体验账号不允许游客访问，退出登陆端
                    BusinessUtil.toLogout();
                    return;
                }
                StorageUtil.setItem(SystemConst.companyName, rs.data.name_);
                StorageUtil.setItem(SystemConst.companyTheme, rs.data.theme_);
                // 商城货币类型
                // StorageUtil.setItem(SystemConst.currencySymbol, rs.data.currency_type_ || "¥");
                document.title = rs.data.shop_home_title_ || rs.data.name_;

                // 检查用户是否微信绑定
                if (!query.code) {
                    CommonUtil.toWechatBind();
                }
                // 设置国际语言
                this.changeLang(rs.data.language_type_);
                CommonUtil.setTheme(rs.data.theme_);
                CommonUtil.setStatisticalCode(rs.data.view_count_url_);

            }
        });
        // 获取企业应用
        InitUtil.getApplicationStatus(companyId);
        // 获取公司设置信息
        CommonUtil.initCompanySetting();
        // 获取应用状态
        // 获取购物车数量
        if (ysUser && !query.code) {
            this.getLoginData();
        }
    }

    toDownLoadApp = () => {
        const ua = navigator.userAgent.toLowerCase();
        const companyId = StorageUtil.getItem(SystemConst.companyId);
        if (/iphone|ipad|ipod/.test(ua)) {
            if (companyId === 4808) {
                window.location.href = 'https://apps.apple.com/cn/app/holamall/id1522198453';
            } else {
                window.location.href = 'https://apps.apple.com/cn/app/holaplaza-mall/id1510484820';
            }
        } else if (/android/.test(ua)) {
            if (companyId === 4808) {
                window.location.href = 'https://img.holaplaza.com/holamall_1.0.0_20200704.apk';
            } else {
                window.location.href = 'https://img.holaplaza.com/holaplaza_3.3.1_20200427.apk';
            }
        }
    };

    componentDidMount() {
        console.log('navigator.userAgent：',navigator.userAgent);
        const companyId = StorageUtil.getItem(SystemConst.companyId);
        let message = 'Para tener una mejor experiencia descarga la App de Holaplaza';
        if (companyId === 4808) {
            message = 'Para tener una mejor experiencia descarga la App de HolaMall';
        }
        // HOL-570
        if (!AppUtil.isApp) { // 非APP环境内打开
            Modal.alert('Notificación', message, [{
                text:  'No gracias',
                onPress: () => {

                }
            }, {
                text: 'Descargar App',
                onPress: () => {
                    this.toDownLoadApp();
                }
            }]);
        }
        //处理微信分享
        loadWxConfig();
        // 统计代码
        this.createAnalyzeCode();
        // 更新页面展示类型和页面滚动节点
        window.addEventListener("setItemEvent", e => {
            if (e.key === SystemConst.BaseSetting) {
                this.setState({
                    baseSetting: JSON.parse(e.newValue)
                })
            }
        });
    }


    createAnalyzeCode = () => {
        const companyId = StorageUtil.getItem(SystemConst.companyId);
        if (companyId === 205) {
            var hm = document.createElement("script");
            hm.src = "https://s5.cnzz.com/z_stat.php?id=1277658265&web_id=1277658265";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
        }
    };
    getLoginData = () => {
        InitUtil.getCartNumber();
        InitUtil.getClientInfo();
    };
    // 切换语言
    changeLang = (lang) => {
        // StorageUtil.setItem(SystemConst.lang, lang);
        this.setState({
            lang: 'es'
        })
    };

    toLogout() {
        //退出到app
        System.logout(null, (response) => {
            if (response.status === 1) {
                BusinessUtil.toLogout();
            }
        })
    }

    toRegister() {
        //退出到app
        BusinessUtil.toLogout('register', true);
    }

    //隐藏弹窗
    hideDialog() {
        this.setState({options: {}})
    }

    setConfirm(obj) {
        this.setState({
            options: {
                type: "confirm",
                ...obj
            }
        })
    }

    //跳转
    toLink(name, query, state) {
        this.props.history.pushState(state, name, query);
    };

    render() {
        const {baseSetting, lang} = this.state;
        const parents = {
            ...this.state,
            changeLang: this.changeLang,
            setConfirm: (obj) => this.setConfirm(obj),
            toLogout: () => this.toLogout(),
            toLogin: () => this.toLogin(),
            hideDialog: () => this.hideDialog(),
            toRegister: () => this.toRegister(),
            toLink: (name, query, state) => this.toLink(name, query, state),
            changeHomePageLoaded: (v) => this.changeHomePageLoaded(v),
        };
        const {children, location} = this.props;
        const interval = 500;
        // 获取动画名称
        const transitionName = CommonUtil.getTransitionName(location);

        const pageCls = classnames({
            'page-ios': AppUtil.isIos,
            'page': !AppUtil.isIos,
            'font-reset': baseSetting.font_style_ === 'bold',
        });
        return (
            <section className={pageCls}>
                <IntlProvider locale={lang} messages={messages[lang] || messages['zh']}>
                    <ReactTransitionGroup
                        component="section"
                        transitionName={transitionName}
                        transitionEnterTimeout={interval}
                        transitionLeaveTimeout={interval}>
                        <div key={location.pathname + location.search}>
                            {React.cloneElement(children || null, parents)}
                        </div>
                    </ReactTransitionGroup>
                </IntlProvider>
                <HdDialog options={this.state.options} hideDialog={() => this.hideDialog()}/>
            </section>
        )
    }
}

// 页面离开记录上一次路由
const onLeave = (prevState) => {
    sessionStorage.setItem('prevLocation', JSON.stringify({
        pathname: prevState.location.pathname,
        query: prevState.location.query,
        search: prevState.location.search,
    }));
    // 设置公司title
    document.title = StorageUtil.getItem(SystemConst.companyName);
};
const onEnter = (nextState, replaceState) => {
    const {state, pathname, query, action} = nextState.location;
    const localHistory = StorageUtil.getItem(SystemConst.localHistory, true) || [];
    const historyLen = localHistory.length;
    if (!query.companyId) {
        // 获取本地companyId
        const companyId = StorageUtil.getItem(SystemConst.companyId);
        if (companyId) {
            replaceState(state, pathname, {
                ...query,
                companyId: companyId
            });
        }
    }
    // 相同路由splice替换
    if (historyLen > 0 && pathname === localHistory[historyLen - 1].pathname) {
        localHistory.splice(historyLen - 1, 1, {state, pathname, query})
    } else {
        localHistory.push({state, pathname, query});
        // 只记录12个路由
        if (historyLen > 12) {
            localHistory.shift()
        }
    }
    StorageUtil.setItem(SystemConst.localHistory, localHistory, true);

};
//遍历返回的route对象，并封装childRoutes所需数组返回
const getChildRoutes = (ChildRoute) => {
    let _arr = [];
    for (let key in ChildRoute) {
        ChildRoute[key].onLeave = onLeave;
        ChildRoute[key].onEnter = onEnter;
        _arr.push(ChildRoute[key]);
    }
    return _arr;
};
const rootRoute = [
    {
        path: '/',
        component: shopComponent,
        indexRoute: ShopRoute.Shop,
        childRoutes: getChildRoutes(ShopRoute)
    },
    {
        path: '/GoodsDetail',
        component: shopComponent,
        indexRoute: ShopRoute.GoodsDetail,
    },
    {
        path: 'shop',
        component: shopComponent,
        indexRoute: ShopRoute.Shop,
        childRoutes: getChildRoutes(ShopRoute)
    }];
//  启动项目
const initApp = () => {
    ReactDom.render(
        <Router routes={rootRoute} history={browserHistory}/>,
        document.getElementById('YsApp')
    );
};

// 启动app
initApp();





// WEBPACK FOOTER //
// ./src/app.js